import React, { useEffect, useState, useCallback } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import ErrorSoundFile from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import HeaderAccount from "./HeaderAccount";
import InterestCard from "./InterestCard";
import moment from "moment";
import TopHeader from "./TopHeader";

const backend = await new Backend().init();

export default function InterestBill() {
  const [playErrorSound] = useSound(ErrorSoundFile);
  const windowSize = useSize();

  const [interest, setInterest] = useState([]);

  const [interestAmount, setInterestAmount] = useState(0);
  const [depositInterestAmt, setDepositInterestAmt] = useState(0);

  const [loading, setLoading] = useState(false);

  const loadInterest = useCallback(
    async (start, end) => {
      setLoading(true);
      try {
        const payload = {
          server: localStorage.getItem("server"),
          id: localStorage.getItem("id"),
          username: localStorage.getItem("username"),
          token: localStorage.getItem("token"),
          user_id: localStorage.getItem("id"),
          start: start || moment().startOf("week"),
          end: end || moment().endOf("week"),
        };

        const response = await backend.interest_bill(payload);
        if (response.error === "False") {
          setInterest(response.interest || []);
          setInterestAmount(response.interest_amount || 0);
          setDepositInterestAmt(response.deposit_interest_amt || 0)
        } else {
          playErrorSound();
          toast.error(response.message || "Failed to load login logs");
        }
      } catch (err) {
        playErrorSound();
        toast.error("Something went wrong while loading logs");
      } finally {
        setLoading(false);
      }
    },
    [playErrorSound]
  );

  useEffect(() => {
    loadInterest();
  }, [loadInterest]);

  return (
    <div className="flex flex-col bg-[var(--background)]">
      {/* Header */}
      <TopHeader onRefresh={loadInterest} />

      <HeaderAccount interestAmount={interestAmount} depositInterestAmt={depositInterestAmt} />

      {/* Main Content */}
      <div className="flex-1 px-4">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <Loading height={windowSize[1] - 150} />
          </div>
        ) : interest.length > 0 ? (
          <div
            style={{
              height: windowSize[1] - 150,
              overflowY: "scroll",
              scrollBehavior: "smooth",
              paddingBottom: 200,
            }}
            className="flex flex-col gap-3"
          >
            {interest.map((item) => (
              <InterestCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 150}
            title="No Interest Bill Found"
            subtext="Try selecting a different date range."
            small
          />
        )}
      </div>
    </div>
  );
}
